import axios from 'axios';
import { message } from 'antd';
message.config({
  maxCount: 3,
});

const baseURL = 'https://mt.api.zztcaigou.cn';
const request = axios.create({
  baseURL,
  timeout: 10000,
});

request.interceptors.request.use(config => {
  const { token, kdtId } = JSON.parse(localStorage.getItem('userInfo') || '{}');
  if (!token) {
    localStorage.removeItem('userInfo');
    window.location.href = '/#/login';
  }
  const { isToken = true, isKdtId = false } = config;
  if (isToken) {
    config.headers['zzt-token'] = token;
  }

  if (isKdtId) {
    config.headers['kdt-id'] = config.kdtId ? config.kdtId : kdtId;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

request.interceptors.response.use(response => {
  const { data: res } = response;
  const { code, data: body } = res;
  if (response.config.url === 'account/downloadAccountInfoTemplate' || response.config.url === 'order/exportOrderInfo') { // 文件下载，返回Blob
    return Promise.resolve(response);
  }

  const logOutCode = [80103, 80104, 80105, 80107];

  if (code !== 200) {
    const msg = res.message || res.msg || '未知错误';
    message.error(msg);

    if (logOutCode.includes(code)) {
      localStorage.removeItem('userInfo');
      window.location.href = '/#/login';
    }

    return Promise.reject(msg);
  }

  return Promise.resolve(body);
}, error => {
  let msg = error.message || error.msg || '未知错误';
  if (msg === 'Network Error') {
    msg = '服务异常，请联系管理员';
  }
  message.error(msg);

  return Promise.reject(error);
});

export default request;
